import React, { useCallback, useEffect, useMemo, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import Select from "react-select";
import { useCostAlloctionBySGBPProducatInformationIdMutation, useLazyGetCertificateGroupingDetailsByIdQuery, useLazyGetProductDetailsListByProductInformationIdQuery, useUpdateApplicationStatusOnPeerReviewerReturnMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import ModalGroupingTable from "./components/ModalGroupingTable";
import CostAllocation from "./components/CostAllocation";
import ToastService from "../../services/toastService/ToastService";
import { useLazyGetPeerReviewEvaluationDetailsByIdQuery, useReturnApplicationToCaseOfficerByPeerReviewerMutation, useSendApplicationToCertificationMutation } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import SwalAlert from "../../services/swalService/SwalService";

const CertificateGroupingList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { confirm } = SwalAlert();
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [productList, setProductList] = useState([]);
  const [costAllocationList, setCostAllocationList] = useState([]);
  const [approver, setApprover] = useState();
  const [peerReviewer, setPeerReviewer] = useState();
  const [peerReviewerComment, setPeerReviewerComment] = useState("")
  const [approverReviewerComment, setApproverReviewerComment] = useState("")

  const [getProductDetailsListByProductInformationId, { isLoading: productListLoading, isSuccess: productListSuccess, data: productListData }] = useLazyGetProductDetailsListByProductInformationIdQuery();
  const [getCertificateGroupingDetailsById, { isLoading: certificateGroupingDetailsLoading, isSuccess: certificateGroupingDetailsSuccess, data: certificateGroupingDetailsData }] = useLazyGetCertificateGroupingDetailsByIdQuery();
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading }] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [saveCertificateGrouping, { isLoading: saveCertificateGroupingLoading, isSuccess: saveCertificateGroupingSuccess, data: saveCertificateGroupingData }] = useCostAlloctionBySGBPProducatInformationIdMutation();
  const [sendToFinalApprover, { isLoading: sendToFinalApproverLoading, isSuccess: sendToFinalApproverSuccess, data: sendToFinalApproverData, },] = useSendApplicationToCertificationMutation();
  const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
  const [returnToCaseOfficer, { isLoading: returnToCaseOfficeLoading, isSuccess: returnToCaseOfficerSuccess, data: returnToCaseOfficerData, },] = useReturnApplicationToCaseOfficerByPeerReviewerMutation();
  const [updateApplicationStatusOnPeerReviewerReturn, { isLoading: updateStatusOnReturnLoading, isSuccess: updateStatusOnReturnLoadingSuccess, data: updateStatusOnReturnLoadingData }] = useUpdateApplicationStatusOnPeerReviewerReturnMutation();

  const approverOptionsMemo = useMemo(() => productsAndServicesDropDownsData?.filter((item) => item.dropdownName === "Approver List")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData, certificateGroupingDetailsData]);

  const itemCodeOptionsMemo = useMemo(() => productsAndServicesDropDownsData
    ?.filter((item) => item.dropdownName === "Items Codes")
    .map((item) => ({ value: item.id, label: item.name })) ?? []
    , [productsAndServicesDropDownsData, certificateGroupingDetailsData]
  );

  const handleSendToFinalApprover = () => {
    let req = {
      sGBPProductInformationId: decryptAESID(id),
      PeerReviewerComment: peerReviewerComment
    }
    if (req) {
      sendToFinalApprover(req)
    }
  };

  const handlePeerReviewerCommentChange = (e) => {
    setPeerReviewerComment(e.target.value);
  };

  useEffect(() => {
    const editID = decryptAESID(id, false);
    if (editID > 0) {
      productsAndServicesDropdown();
      getProductDetailsListByProductInformationId(editID);
      getCertificateGroupingDetailsById(editID);
      getPeerReviewEvaluationDetailsById(editID);
    }
  }, [id]);

  useEffect(() => {
    if (!productListLoading && productListSuccess && productListData) {
      setProductList(productListData);
    }
  }, [productListLoading, productListSuccess, productListData]);

  useEffect(() => {
    if (!certificateGroupingDetailsLoading && certificateGroupingDetailsSuccess && certificateGroupingDetailsData) {
      let data = certificateGroupingDetailsData?.allocationCostList.map((item) => ({
        label: item?.certificateNumber,
        value: item?.itemCode,
        id: item?.sgbpCertificateGroupingId
      }))
      setCostAllocationList(data);
      const peerReviewerOption = approverOptionsMemo?.find((item) => item.value === certificateGroupingDetailsData?.peerReviewerId);
      const approverOption = approverOptionsMemo?.find((item) => item.value === certificateGroupingDetailsData?.approverId);
      setPeerReviewer(peerReviewerOption || null);
      setApprover(approverOption || null);
    }
  }, [certificateGroupingDetailsLoading, certificateGroupingDetailsSuccess, certificateGroupingDetailsData, productsAndServicesDropDownsData]);

  useEffect(() => {
    if (!saveCertificateGroupingLoading && saveCertificateGroupingData && saveCertificateGroupingSuccess) {
      ToastService.success("Certificate Data Save Successfully!");
    }
  }, [saveCertificateGroupingLoading, saveCertificateGroupingData, saveCertificateGroupingSuccess]);

  useEffect(() => {
    if (!sendToFinalApproverLoading && sendToFinalApproverSuccess && sendToFinalApproverData) {
      if (!sendToFinalApproverData.hasError) {
        ToastService.success("Application Sent to Final Approver Successfully");
        navigate("/viewApplicationTaskList")
      } else {
        ToastService.error(sendToFinalApproverData.errorMessage);
      }
    }
  }, [sendToFinalApproverLoading, sendToFinalApproverSuccess, sendToFinalApproverData]);

  useEffect(() => {
    if (!getPeerReviewEvaluationDetailsByIdLoading && getPeerReviewEvaluationDetailsByIdSuccess && getPeerReviewEvaluationDetailsByIdData) {
      setPeerReviewerComment(getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment)
      setApproverReviewerComment(getPeerReviewEvaluationDetailsByIdData?.finalApproverComment)
    }
  }, [getPeerReviewEvaluationDetailsByIdLoading, getPeerReviewEvaluationDetailsByIdSuccess, getPeerReviewEvaluationDetailsByIdData]);

  useEffect(() => {
    if (!returnToCaseOfficeLoading && returnToCaseOfficerSuccess && returnToCaseOfficerData) {
      if (!returnToCaseOfficerData.hasError) {
        ToastService.success("Application Returned to Case Officer");
        navigate("/viewApplicationTaskList");
      } else {
        ToastService.error(returnToCaseOfficerData.errorMessage);
      }
    }
  }, [returnToCaseOfficeLoading, returnToCaseOfficerSuccess, returnToCaseOfficerData]);
  const handleCombine = () => {
    setShowAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
  };

  const handleReturn = () => {
    confirm('Return?', 'Are you sure you want to return?', 'Return', 'Cancel').then((confirmed) => {
      if (confirmed) {
        handleReturnApplication();
      }
    });
  };

  const handleReturnApplication = () => {
    let req = {}
    req.sGBPProductInformationId = decryptAESID(id);
    req.peerReviewerComment = peerReviewerComment
    req.FinalApproverComment = approverReviewerComment
    if (req) {
      returnToCaseOfficer(req);
      updateApplicationStatusOnPeerReviewerReturn({ SGBPProductInformationId: decryptAESID(id) });
    }
  };

  const handleBack = () => {
    navigate(`/caseOfficerEvaluation/${id}`);
  };

  const handleSave = useCallback(() => {
    const applicationId = decryptAESID(id?.toString(), false);
    const req = {
      comments: certificateGroupingDetailsData?.commentFromCaseOfficer,
      peerReviewerId: peerReviewer?.value,
      approverId: approver?.value,
      sGBPSApplicationId: applicationId,

      costAllocationRequestListRequest: costAllocationList.map((row) => {
        if (row.value == null) return;
        const [certificateNumber, certPrefix] = row.label.split("/");
        const prefix = Number(certPrefix);
        return {
          itemCode: row.value,
          certificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
          // certPrefix: certPrefix ? Number(certPrefix) : null,
          certPrefix: certPrefix === undefined || prefix === 0 ? null : prefix,
          sGBPSApplicationId: applicationId,
          sgbpCertificateGroupingId: row?.id ?? 0,
        };
      }).filter(Boolean),

      modelGroupingRequestListRequest: productList.map(
        ({ textValue, rating, certPrefix, sgbpProductId, applicationNumber }) => ({
          sgbpProductId,
          textValue,
          rating: Number(rating),
          // certPrefix: Number(certPrefix),
          certPrefix: Number(certPrefix) === 0 ? null : Number(certPrefix),
          certificateNumber: String(applicationNumber),
        })
      ),
    };
    saveCertificateGrouping(req);
  }, [id, peerReviewer, approver, costAllocationList, productList, saveCertificateGrouping]);



  return (
    <div className="certificate-grouping-list-page">
      <div className="crud-requirement-list">
        <div className="corporate-member-list">
          <ModalGroupingTable
            data={productList}
          />
          <CostAllocation
            rows={costAllocationList}
            options={itemCodeOptionsMemo}
          />
          <div className="table-title mt-5 mb-4">
            <h3>Internal Notes</h3>
          </div>
          <div className="mt-2">
            <label className="form-label">Comments from Case Officer</label>
            <textarea disabled
              className="form-control mt-1"
              rows="4"
              value={certificateGroupingDetailsData?.commentFromCaseOfficer}
            ></textarea>
          </div>
          <div className="mt-2">
            <label className="form-label">Peer Reviewer Comment</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              value={peerReviewerComment}
              onChange={handlePeerReviewerCommentChange}
            ></textarea>
          </div>
          <div className="mt-2">
            <label className="form-label">Approver Reviewer Comment</label>
            <textarea
              className="form-control mt-1"
              rows="4"
              value={approverReviewerComment}
              disabled
            ></textarea>
          </div>
          <div className="table-title mt-5 mb-4">
            <h3>Assign to</h3>
          </div>
          <div className="dropdown-select-wrapper">
            <div className="d-flex align-items-center mb-4">
              <label className="form-label mb-0 w-20">Peer Reviewer <span className="text-danger">*</span> </label>
              <Select
                className="custom-checkbox-select"
                value={peerReviewer}
                options={approverOptionsMemo}
                isDisabled={true}
              />
            </div>
            <div className="d-flex align-items-center">
              <label className="form-label mb-0 w-20">Approver <span className="text-danger">*</span></label>
              <Select
                className="custom-checkbox-select"
                value={approver}
                options={approverOptionsMemo}
                isDisabled={true}
              />

            </div>
          </div>
          <div className="d-flex justify-content-between mt-5">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="black-btn"
              onClick={handleBack}
            />
            <div className="d-flex gap-3">
              {/* <Buttons
                buttonText="Save +++++"
                buttonTypeClassName="search-btn"
                onClick={handleSave}
                isLoading={saveCertificateGroupingLoading}
                isDisable={saveCertificateGroupingLoading}
              /> */}
              <Buttons
                buttonText="Return"
                buttonTypeClassName="reject btn"
                onClick={handleReturn}
                isLoading={returnToCaseOfficeLoading || updateStatusOnReturnLoading}
                isDisable={returnToCaseOfficeLoading || sendToFinalApproverLoading || updateStatusOnReturnLoading}
              />

              <Buttons
                buttonText="Recommend for Certification"
                buttonTypeClassName="success-btn"
                onClick={handleSendToFinalApprover}
                isLoading={sendToFinalApproverLoading}
                isDisable={sendToFinalApproverLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateGroupingList;
